import { Layout } from "antd";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dummy from "../Components/Dummy";
import AppLayout from "../Components/Layout/Layout";
import LineOperatorComp from "../Components/LineOperatorComp/LineOperatorComp";
import LoginPage from "../Components/Login/LoginPage";
import Homepage from "../Pages/Homepage/Homepage";
import HomepageOee from "../Pages/OEE/Homepage.oee";
import PlantSettings from "../Pages/PlantSettings/PlantSettings";
import Integrations from "../Pages/Integrations/Integrations";
import DowntimeLog from "../Components/DowntimeLog/DowntimeLog";
import { pageRoutes } from "./pageRoutes";
import PrivateRoutes from "./PrivateRoutes";
import CustomUserTable from "../Components/Table/CustomUserTable";
import PlantsettingRole from "../Pages/PlantSettings/plantsettingRole";
import LineSettings from "../Components/Line Settings/LineSettings";
import LineBoard from "../Components/LineBoard/LineBoard";
import AuditTrail from "../Components/OEE/AuditTrail/AuditTrail";
import Dashboard from "../Pages/OEE/Dashboard.oee";
import LineCharttt from "../Components/OEE/LinePerMonitor/LineChart";

import LineCharttwo from "../Components/OEE/LinePerMonitor/LineCharttwo";
import LinePerMonitor from "../Pages/OEE/LinePerMonitor.oee";
import LineLevelBoard from "../Components/LineLevelBoard/LineLevelBoard";
const RouteHandler = () => {

  return (

    <Router>
      <Routes>

        {/* Auth Routes */}
        <Route exact path={pageRoutes.login} element={<LoginPage />} />


        {/* Protected Routes */}
        <Route element={<PrivateRoutes />}>
          {/* Dummy Route */}
          {/* <Route path={pageRoutes.dashboard} element={<Dashboard />} /> */}
        </Route>
        <Route path={pageRoutes.dashboard} element={<AppLayout home={true} sidebarKey={1} children={<Dashboard />} />} />
        <Route path={pageRoutes.lineOperator} element={<AppLayout sidebarKey={8} children={<LineOperatorComp />} />} />
        <Route path={pageRoutes.LineLevelBoard} element={<AppLayout sidebarKey={4} children={<LineLevelBoard />} />} />
        <Route path={pageRoutes.plantSettings} element={<AppLayout sidebarKey={11} children={<PlantSettings />} />} />
        <Route path={pageRoutes.integrations} element={<AppLayout sidebarKey={12} children={<Integrations />} />} />
        <Route path={pageRoutes.downtimeLog} element={<AppLayout sidebarKey={9} children={<DowntimeLog />} />} />
        <Route path={pageRoutes.lineSettings} element={<AppLayout sidebarKey={10} children={<LineSettings />} />} />
        <Route path={pageRoutes.lineBoard} element={<AppLayout sidebarKey={5} children={<LineBoard />} />} />
        <Route path={pageRoutes.AuditTrail} element={<AppLayout sidebarKey={13} children={<AuditTrail />} />} />
        <Route path={pageRoutes.oee.linePerformanceMonitor} element={<AppLayout sidebarKey={11} children={<LinePerMonitor />} />} />
        <Route path={pageRoutes.oee.homepage} element={<AppLayout sidebarKey={0} children={<HomepageOee />} />} />
        {/* Component Routes */}

      </Routes>
    </Router>
  )
};

export default RouteHandler;
